<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>

<main role="main">
    <h2 id="evidences-title">
        {{ 'evidences-upload.title' | translate }}
        <small>
            <span *ngIf="signerService.signerName()">- {{signerService.signerName()}}</span>
        </small>
    </h2>

    <section class="infoBox">
        <div>
            <p id="evidences-info">{{ infoBoxMsg | translate:{details: infoBoxDetails} }}
                <app-wl-electronic-signature-purpose class="right"></app-wl-electronic-signature-purpose>
            </p>
        </div>
    </section>

    <!--    Template Global-->
    <section *ngIf="isGlobal()">
        <form (ngSubmit)="goToNextStep()" id="evidenceForm">
            <div class="evidenceSection inputFile transitions-enabled masonry"
                 *ngFor="let evidenceWithTemp of evidencesWithTemp; let index = index">
                <app-wl-evidence [evidencewithtemp]="evidenceWithTemp" [num]="index + 1"></app-wl-evidence>
            </div>

            <div class="ic-warning" *ngIf="numberToUpload > 0">
                <h6 id="evidence-missing-warning">{{ numberToUpload }} {{ 'evidences.evidence.missing' | translate }}</h6>
            </div>
            <p class="k-buttons-bar">
                <input id="evidences-on-hold" type="button" *ngIf="onHoldAvailability && !onHoldLimitReached"
                       value="{{ 'confirmCancellation.hold' | translate }}" class="k-button k-button-primary" (click)="hold()"/>
                <input id="evidences-submit" type="submit" value="{{ 'evidences.next' | translate }}" class="k-button ic-check"
                       [disabled]="buttonDisabled"/>
            </p>
        </form>
    </section>

    <section *ngIf="isCropping()">
        <div class="cropable-evidence">
            <app-wl-evidence-to-crop [evidenceWithTemp]="evidenceToCrop" [nbPages]="nbPages"></app-wl-evidence-to-crop>
        </div>
    </section>

    <section *ngIf="isAnalyse()">
        <!--        TODO MTSSIGNBOX-1551 analyse page-->
        <form (ngSubmit)="goToNextStep()" id="evidenceForm">
            <div *ngIf="evidenceAnalysisInProgress()">
                <h3 id="evidence-preview-pending">{{ 'evidence.analysis' | translate}}</h3>
                <p class="historic content" id="evidence-analysis-pending">
                    <span class="glyphicon glyphicon-ok"></span>
                    {{ 'analysis.message' | translate }}
                </p>
            </div>

            <div *ngIf="evidenceAnalysisToValidate() || evidenceAnalysisError()">
                <!-- Title -->
                <h3>{{ 'evidence.preview' | translate }} </h3>
                <div uib-carousel active="active" no-wrap="noWrapSlides">
                    <div uib-slide *ngFor="let slide of slides; let index = index">
                        <figure>
                            <a (click)="openPreview(slide.image)">
                                <div class="carousel-container">
                                    <img class="carousel-image" [src]="slide.image">
                                    <span class="carousel-corner-image glyphicon"
                                          [ngClass]="slide.status === 'ERROR' ||  slide.status === 'TO_VALIDATE'? 'glyphicon-remove carousel-corner-image-ko' : ''"></span>
                                </div>
                            </a>
                            <figcaption><p class="carousel-text">{{slide.text}}</p></figcaption>
                        </figure>
                    </div>
                </div>
            </div>

            <section>
                <p class="k-buttons-bar" [hidden]="spinneractive">
                    <input class="k-button" data-*ngIf="!evidenceAnalysisToValidate()"
                           (click)="retryLoadEvidences()" type="button"
                           value="{{ 'evidences.evidence.retry' | translate:{NBTRY : nbEvidenceTry()} }}"/>
                    <input class="k-button k-button-primary" data-*ngIf="!evidenceAnalysisError() && onHoldAvailability && !onHoldLimitReached"
                           (click)="hold()"
                           type="button"
                           value="{{ 'confirmCancellation.hold' | translate }}"/>
                    <input class="k-button" data-*ngIf="isForceAllowed()" (click)="confirmForce()" type="button"
                           value="{{ 'evidences.evidence.force' | translate }}"/>
                </p>
            </section>


        </form>
    </section>

    <p class="back-link" [hidden]="spinneractive">
        <span id="cancel-link" (click)="confirmCancel()">{{ 'evidences.cancel' | translate }}</span>
        <span *ngIf="errorMsg">{{ errorMsg | translate }}</span>
    </p>
</main>
